import Loadable from "react-loadable";
import { EmptyComponent } from "../common/EmptyComponent";

export const GreetingBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/greeting" */
      "./components/GreetingBox/GreetingBox"
    ),
  loading: EmptyComponent
});

export const BalanceBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/balance" */ "./components/BalanceBox/BalanceBox"
    ),
  loading: EmptyComponent
});

export const NotificationBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/notification" */ "./components/NotificationBox/NotificationBox"
    ),
  loading: EmptyComponent
});

export const LoyaltyIndicatorBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/loyalty" */ "../LoyaltyIndicator/LoyaltyIndicatorBox"
    ),
  loading: EmptyComponent
});

export const ControlCenterBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/control-center" */ "./components/ControlCenter/ControlCenterBox"
    ),
  loading: EmptyComponent
});

export const HistoryBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/history" */ "./components/HistoryBox/HistoryBox"
    ),
  loading: EmptyComponent
});

export const UsefulLinkBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/useful-links" */ "./components/UsefulLinksBox/UsefulLinksBox"
    ),
  loading: EmptyComponent
});

export const LinkItemChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/link-item" */ "./components/LinkItem/LinkItem"
    ),
  loading: EmptyComponent
});

export const LinksBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/links" */ "./components/LinksBox/LinksBox"
    ),
  loading: EmptyComponent
});

export const BiometricLinkChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/biometrics-link" */ "./components/BiometricLink/BiometricLink"
    ),
  loading: EmptyComponent
});
